import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText, Inbox, CheckCircle2, UserPlus, Radio, Send } from "lucide-react";
import PublicLayout, { PageHero } from "../../components/PublicLayout";
import { useLang } from "../../context/LanguageContext";

const iconsOrg = [FileText, Inbox, CheckCircle2];
const iconsTal = [UserPlus, Radio, Send];

const HowItWorks = () => {
  const { t } = useLang();
  const [tab, setTab] = useState(0);
  const tabs = t("pages.how.tabs");
  const steps = tab === 0 ? t("pages.how.organisers") : t("pages.how.talents");
  const icons = tab === 0 ? iconsOrg : iconsTal;
  return (
    <PublicLayout>
      <PageHero eyebrow={t("pages.how.eyebrow")} title={t("pages.how.title")} subtitle={t("pages.how.subtitle")} />
      <section className="max-w-[1000px] mx-auto px-6 pb-24">
        <div className="flex justify-center">
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-[#181818] border border-[#2A2A2A]">
            {tabs.map((tl, i) => (<button key={tl} onClick={() => setTab(i)} className={`px-5 py-2 rounded-full text-[14px] font-medium transition-colors ${tab === i ? "bg-[#1A8A4A] text-white" : "text-neutral-400 hover:text-white"}`}>{tl}</button>))}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={s.step} className="rounded-2xl border border-[#2A2A2A] bg-[#181818] p-7">
                <div className="flex items-center gap-3"><div className="w-12 h-12 rounded-xl bg-[#FF5C00] flex items-center justify-center text-white font-bold text-[16px]">{s.step}</div><Icon size={20} className="text-[#FF5C00]" /></div>
                <h3 className="mt-6 text-[19px] font-semibold text-white">{s.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-neutral-400">{s.text}</p>
              </div>
            );
          })}
        </div>
        <div className="mt-14 text-center">
          <Link to={tab === 0 ? "/boka" : "/signin"} className="inline-flex items-center gap-2 bg-[#1A8A4A] hover:bg-[#20A458] text-white font-semibold px-7 py-3.5 rounded-xl transition-colors">{tab === 0 ? t("pages.how.ctaOrg") : t("pages.how.ctaTal")} <ArrowRight size={18} /></Link>
        </div>
      </section>
    </PublicLayout>
  );
};

export default HowItWorks;
